import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroBadges, heroImage } from '../data/copy';
const contents = ['6 Complete Teaching Volumes', '120 Ready-to-Teach Classes', '7 Practical Teacher Bonuses'];
export function Hero() {
  return <header className="w-full bg-ivory" data-id="element-93" data-mp="4mru70n4vzl8">
      <div className="mx-auto max-w-4xl px-6 pb-12 pt-7 text-center sm:pt-10 lg:pb-16" data-id="element-94" data-mp="4jm5hmif2zq1">
        <Pill tone="sage" className="mx-auto max-w-[19rem] text-center leading-[1.7] sm:max-w-none" data-id="element-95" data-mp="128pijeo72z53">
          For yoga teachers tired of planning every class from scratch
        </Pill>

        <h1 className="mx-auto mt-4 max-w-3xl font-display text-[1.9rem] leading-[1.08] text-ink sm:text-5xl lg:text-[3.5rem]" data-id="element-96" data-mp="s9q6rn84undv">
          What if your next months of yoga classes were{' '}
          <span className="text-sage" data-id="element-97" data-mp="3d2bkprwf73wl">already planned?</span>
        </h1>

        {/* The complete product mockup sits directly under the question. */}
        <div className="relative mt-7" data-id="element-98" data-mp="3j8iw0w4jiat4">
          <div className="absolute inset-x-0 bottom-6 top-12 rounded-4xl bg-sand" aria-hidden="true" data-id="element-99" data-mp="3j9k730lk2xau" />
          <img src={heroImage} alt="The complete Yoga Teaching Vault™: six teaching volumes, seven bonus books and printable teaching resources." className="relative mx-auto w-full max-w-[19rem] sm:max-w-lg lg:max-w-2xl" width={1240} height={1240} decoding="async" data-id="element-100" data-mp="3o6apvvoqw6zy" />
        </div>

        
        <p className="mx-auto mt-3 max-w-readable font-sans text-[0.95rem] leading-relaxed text-stone sm:text-base" data-id="element-101" data-mp="30gzw4y5tbcvb">
          The complete ready-to-teach system for yoga teachers who want to plan
          less and never wonder “what am I teaching tomorrow?” again.
        </p>

        {/* First CTA — jumps straight to the offer section, where the price is. */}
        <div className="mt-6" data-id="element-102" data-mp="2hj5ig6tqod6l">
          <CtaButton href="#offer" size="large" className="w-full sm:w-auto" data-id="element-103" data-mp="2hk83vz8alnf4">
            Get Yoga Teaching Vault™
          </CtaButton>
        </div>

        <ul className="mx-auto mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 font-sans text-[0.72rem] font-medium uppercase tracking-[0.1em] text-sage-deep sm:text-[0.8rem]" data-id="element-104" data-mp="2lml82j7e5d9s">
          {contents.map((item, index) => <li key={item} className="flex items-center gap-4" data-id="element-105" data-mp="ibozop5huuwh" data-mpi={index}>
              {item}
              {index < contents.length - 1 ? <span className="h-1 w-1 rounded-full bg-gold" aria-hidden="true" data-id="element-106" data-mp="ddwzl7up42h7" /> : null}
            </li>)}
        </ul>

        <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-107" data-mp="1azkqjd8dtslc">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-stone sm:text-xs" data-id="element-108" data-mp="162c9xh2vtwm7">
              <CheckIcon className="h-3.5 w-3.5 text-sage" strokeWidth={2.4} aria-hidden="true" data-id="element-109" data-mp="110wp9q4m9s4c" />
              {badge}
            </li>)}
        </ul>
      </div>
    </header>;
}